module.exports = __webpack_public_path__ + "img/8.67617c30.png";